import React, {useEffect} from "react"
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../../../../../_metronic/layout";
import * as handlers from "../../../../../_redux/selected-user/selectedUserHandlers";
import Overview from "./account-pages/overview/Overview"
import ProfileDetailSkeleton from "./../profile-detail/ProfileDetailSkeleton"
import AccountLayout from "./account-layout/AccountLayout";
import Transactions from "./account-pages/transactions/Transactions";
import Payments from "./account-pages/payments/Payments";
import Orders from "./account-pages/orders/Orders";
import Postions from "./account-pages/positions/Positions";
import Statements from "./account-pages/statements/Statements";
import Meta from "./account-pages/meta/Meta";

const AccountInformation = props => {
    
    const accounts = useSelector(({selectedUser}) => selectedUser.data.accounts, shallowEqual);
    // Redux dispatch
    const dispatch = useDispatch();

    /* Fetch User Account List if not in redux */
    useEffect(() => {
        if (!accounts){
            dispatch(handlers.fetchUserAccounts(props.match.params.userId));
        }
    }, [dispatch, props.match.params.userId, accounts]);

    return ( accounts ? 
            <AccountLayout {...props} >
                <Switch>
                    <ContentRoute path="/users/view/:userId/account-information/:accountId/overview" component={Overview} />
                    <ContentRoute path="/users/view/:userId/account-information/:accountId/positions" component={Postions} />
                    <ContentRoute path="/users/view/:userId/account-information/:accountId/orders" component={Orders} />
                    <ContentRoute path="/users/view/:userId/account-information/:accountId/transactions" component={Transactions} />
                    <ContentRoute path="/users/view/:userId/account-information/:accountId/payments" component={Payments} />
                    <ContentRoute path="/users/view/:userId/account-information/:accountId/statements" component={Statements} />
                    <ContentRoute path="/users/view/:userId/account-information/:accountId/meta" component={Meta} />

                    <Redirect from="/users/view/:userId/account-information/:accountId" to="/users/view/:userId/account-information/:accountId/overview"/>
                </Switch>
            </AccountLayout>
            :
            <ProfileDetailSkeleton />
    )
}

export default AccountInformation;